import { render, staticRenderFns } from "./TableActivitiesImportContainer.vue?vue&type=template&id=bb3cc99c&"
import script from "./TableActivitiesImportContainer.vue?vue&type=script&lang=ts&setup=true&"
export * from "./TableActivitiesImportContainer.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports